import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { TableColumn } from 'src/app/models/table-columns';
import { ShortCodeHistoryResult, ShortCodesService } from 'src/app/services/shortcodes.service';
import { Router } from '@angular/router';
import { ScrBaseService } from 'src/app/services/base.service';

@Component({
  templateUrl: './code-history.component.html',
  styleUrls: ['./code-history.component.scss']
})
export class CodeHistoryComponent extends ScrBaseComponent implements OnInit {

  shortCodeValue!: string;
  shortCodeDisplay?: string;
  shortCodeStatus?: string;
  apiMessage?: string;
  shortCodeHistory?: ShortCodeHistoryResult;
  searchShortCodeValue = '';

  tableColumn: TableColumn[] = [
    { field: 'scId' },
    { field: 'company', localizationKey:'organizationName' },
    { field: 'accountId' },
    { field: 'orderId' },
    { field: 'applicationType' },
    { field: 'codeType' },
    { field: 'term' },
    { field: 'applicationDate' },
    { field: 'endDate' },
    { field: 'ageDate' },
    { field: 'comments' }
  ];

  constructor(private shortCodesService: ShortCodesService, private router: Router) {
    super();
  }

  ngOnInit(): void {
    if (history.state?.shortCode) {
      this.shortCodeValue = history.state.shortCode;
      this.fetchScHistory();
    }
    // localize the table columns.
    this.localizeTableColumns(this.tableColumn);
  }

  fetchScHistory(): void {
    this.shortCodeHistory = undefined;
    this.shortCodeDisplay = '';
    this.apiMessage = '';
    this.searchShortCodeValue = ScrBaseService.shortCodeToNumeric(this.shortCodeValue);
    if (ScrBaseService.isInvalidShortCode(this.shortCodeValue)) {
      this.displayLocalizedError("scr.shortcode.invalid");
      const elmt = document.getElementById('messages');
      elmt?.scrollIntoView({ behavior: "smooth" });
      return;
    }

    const strRegex = new RegExp("^[a-zA-Z2-9*][a-zA-Z0-9*]{4,5}$");

    // match the regex with the string
    const result = strRegex.test(this.shortCodeValue);
    if (!result) {
      this.displayLocalizedError("scr.shortcode.invalid");
      return;
    }
    this.observe(this.shortCodesService.shortCodeHistory(this.searchShortCodeValue), {
      onSuccess: (res) => {
        this.shortCodeDisplay = ScrBaseService.shortCodeToNumeric(this.shortCodeValue);
        if (res.data?.codes) {
          this.shortCodeHistory = res.data;
          this.shortCodeStatus = res.data.scStatus;
          if (res.data.codes.length) {
            this.apiMessage = `Short Code ${this.shortCodeDisplay} is ${this.shortCodeStatus}.`;
          } else {
            this.shortCodeHistory = undefined;
            this.apiMessage = `Short Code ${this.shortCodeDisplay} is ${this.shortCodeStatus}. No history was found for this short code.`;
          }
        } else if (res.messages && res.messages.length) {
          this.apiMessage = `${res.messages[0].message} `;
        }
        return false;
      }
    });
  }

  submit(form: NgForm) {
    this.clearMessages();
    if (!form.valid) {
      this.scrollToFirstError();
      return;
    }
    this.fetchScHistory();
  }

  navigateLookup(shortCode: string) {
    this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['code-management', { outlets: { 'code-management-tab': ['code-lookup'] } }] } }], { state: { shortCode: shortCode } });
  }

  exportExcel(): void {

    this.shortCodesService.shortCodeHistoryDownload(this.searchShortCodeValue).subscribe({
      next: (rsp) => {
        this.shortCodesService.processBlobResponseDownload(rsp);
      },
      error: (error) => {
        this.processHttpScrErrorResponse(error); this.jumpToTop();
      }
    });

  }
}
